"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input-number/style/css");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

var _react = _interopRequireWildcard(require("react"));

var _ = _interopRequireWildcard(require("lodash"));

var _uuid = _interopRequireDefault(require("uuid"));

var _form = _interopRequireDefault(require("antd/lib/form"));

require("../activity.scss");

var _DynamicQuestionItems = _interopRequireDefault(require("../questions/DynamicQuestionItems"));

var _DynamicOptionItems = _interopRequireDefault(require("../options/DynamicOptionItems"));

var _ChooseYourOwnAdventure = _interopRequireDefault(require("../chooseYourOwnAdventure/ChooseYourOwnAdventure"));

var _ScreenerQuestionForm = _interopRequireDefault(require("../screener/ScreenerQuestionForm"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
var Type;

(function (Type) {
  Type[Type["zero"] = 0] = "zero";
  Type[Type["quiz"] = 1] = "quiz";
  Type[Type["category"] = 2] = "category";
  Type[Type["category_no_answer"] = 3] = "category_no_answer";
  Type[Type["cyoa"] = 4] = "cyoa";
  Type[Type["fill_in_the_blank"] = 5] = "fill_in_the_blank";
  Type[Type["goals"] = 6] = "goals";
  Type[Type["ranking"] = 7] = "ranking";
  Type[Type["screener"] = 8] = "screener";
})(Type || (Type = {}));

const itemStyle = {
  width: '100%',
  marginBottom: '10px',
  marginTop: '10px'
};
const defaultQuestion = {
  text: '',
  uuid: '',
  randomizeOptions: false,
  numBlanks: undefined,
  options: [],
  correctOptionId: undefined,
  feedback: []
};
const defaultOption = {
  text: '',
  uuid: '',
  points: 0,
  isCorrect: false,
  correctPosition: undefined,
  feedback: undefined
};

class ActivityQuestionForm extends _react.Component {
  constructor() {
    super(...arguments);
    this.form = /*#__PURE__*/_react.default.createRef(); // Action Handlers

    this.updateQuestions = questions => {
      const {
        setActivity,
        activity
      } = this.props;
      activity.questions = questions;
      setActivity({
        questions
      });
    };

    this.updateOptions = options => {
      const {
        setActivity,
        activity
      } = this.props;
      activity.options = options;

      if (activity.typeId === Type.ranking) {
        // If activity type is ranking, the correctPosition
        // is just the position in the array.
        for (let i = 0; i < options.length; i++) {
          options[i].correctPosition = i;
        }
      }

      setActivity({
        options
      });
    };

    this.addQuestion = () => {
      const {
        activity
      } = this.props;
      const {
        questions
      } = activity;
      let updatedQuestions = questions ? _.cloneDeep(questions) : [];

      const newQuestion = _.cloneDeep({ ...defaultQuestion,
        uuid: (0, _uuid.default)()
      });

      if (!questions) {
        updatedQuestions = [newQuestion];
      } else {
        updatedQuestions[updatedQuestions.length] = newQuestion;
      }

      this.updateQuestions(updatedQuestions);
    };

    this.removeQuestion = index => {
      const {
        activity
      } = this.props;
      const {
        questions
      } = activity;
      let i = 0;
      const update = questions ? questions.filter(q => {
        return index !== i++;
      }) : [];
      this.updateQuestions(update);
    };

    this.updateQuestion = (q, index) => {
      const {
        activity
      } = this.props;
      const {
        questions
      } = activity;

      if (questions) {
        questions[index] = q;
        this.updateQuestions(questions);
      }
    };

    this.updateOption = (option, index) => {
      const {
        activity
      } = this.props;
      const {
        options
      } = activity;

      if (options) {
        options[index] = _.cloneDeep(option);
        this.updateOptions(options);
      }
    };

    this.addOption = () => {
      const {
        activity
      } = this.props;
      const {
        options
      } = activity;
      let updatedOptions = options ? _.cloneDeep(options) : [];

      const newOption = _.cloneDeep({ ...defaultOption,
        uuid: (0, _uuid.default)()
      });

      if (!options) {
        updatedOptions = [newOption];
      } else {
        updatedOptions[updatedOptions.length] = newOption;
      }

      this.updateOptions(updatedOptions);
    };

    this.removeOption = index => {
      const {
        activity
      } = this.props;
      let {
        options
      } = activity;
      let i = 0;
      options = options ? options.filter(o => {
        return index !== i++;
      }) : [];
      this.updateOptions(options);
    };

    this.swapOptionPosition = (indexA, indexB) => {
      const {
        activity
      } = this.props;
      const {
        options
      } = activity;

      if (options && (indexA < indexB && indexB < options.length || indexA > indexB && indexB >= 0)) {
        const temp = _.cloneDeep(options[indexA]);

        options[indexA] = _.cloneDeep(options[indexB]);
        options[indexB] = temp;
        this.updateOptions(options);
      }
    };

    this.onNumToSelectChange = value => {
      const {
        activity,
        setActivity
      } = this.props;

      if (value) {
        activity.numToSelect = Number(value);
        setActivity({
          numToSelect: value
        });
      }
    };

    this.validateNumToSelect = (rule, value) => {
      const {
        activity
      } = this.props;
      const {
        numToSelect
      } = activity;

      try {
        if (!numToSelect) {
          throw new Error('numToSelect is required.');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };
    /**
     * Validation method which determines whether every question
     * and option has the text property populated
     *
     * *NOTE* doesn't test for cyclical graphs
     *
     * @returns boolean representing whether the passed in tree structure
     * is valid
     */


    this.validateTree = (rule, value) => {
      const {
        activity
      } = this.props;

      try {
        if (!activity.tree) {
          throw new Error('Invalid tree.');
        }

        const {
          questions,
          options
        } = activity.tree;

        if (_.isEmpty(questions) || questions.size === 0) {
          throw new Error('No questions defined.');
        }

        for (const entry of questions) {
          const [id, question] = entry;

          if (id !== question.id || !question.text || question.text.length === 0) {
            throw new Error('Questions must have text.');
          }
        }

        if (_.isEmpty(options) || options.size === 0) {
          throw new Error('No options defined.');
        }

        for (const entry of options) {
          const [id, option] = entry;

          if (id !== option.id || !option.text || option.text.length === 0) {
            throw new Error('Options must have text.');
          }

          if (!option.questionId) {
            throw new Error('Every option must have a question.');
          }
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };

    this.updateTree = (tree, firstId) => {
      const {
        setActivity
      } = this.props;

      if (tree) {
        setActivity({
          tree,
          firstId
        });
      }
    }; // Custom Field Validators


    this.validateQuestions = (rule, value) => {
      const {
        activity
      } = this.props;

      try {
        const {
          questions
        } = activity;

        if (!questions || questions.length === 0) {
          throw new Error('No questions defined');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };

    this.validateOptions = (rule, value) => {
      const {
        activity
      } = this.props;

      try {
        const {
          options
        } = activity;

        if (options && options.length) {
          options.forEach(o => {
            if (o.text.length === 0) {
              throw new Error('Option text is required');
            }

            if (activity.typeId === Type.screener && !o.groupId) {
              throw new Error('Screener options must be assigned to a group');
            }
          });
        } else {
          throw new Error('No options defined');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };
  }

  componentDidMount() {
    const {
      setActiveForm
    } = this.props;

    if (this.form.current) {
      setActiveForm(this.form.current);
    }
  } // Renderers


  render() {
    const {
      activity,
      creative,
      editable
    } = this.props;
    const {
      questions,
      options,
      numToSelect,
      tree,
      firstId,
      typeId
    } = activity;
    const displayActivityOptions = [Type.category, Type.category_no_answer, Type.ranking, Type.goals].indexOf(typeId) > -1;
    const displayQuestions = [Type.goals, Type.ranking, Type.cyoa, Type.screener].indexOf(typeId) === -1;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-form"
    }, typeId !== Type.cyoa && typeId !== Type.screener && /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "form",
      layout: "horizontal",
      colon: false
    }, typeId === Type.goals && /*#__PURE__*/_react.default.createElement(Item, {
      required: true,
      key: "numToSelect",
      name: "numToSelect",
      style: itemStyle,
      validateTrigger: ['onChange', 'onSubmit', 'onBlur', 'onFocus'],
      rules: [{
        required: true,
        message: 'Please set how many goals the participant is required to select.',
        validator: this.validateNumToSelect
      }]
    }, /*#__PURE__*/_react.default.createElement("span", null, "Require user to select", ' ', /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
      disabled: !creative && !editable,
      defaultValue: numToSelect,
      min: 0,
      onChange: this.onNumToSelectChange
    }), ' ', "items.")), displayActivityOptions && /*#__PURE__*/_react.default.createElement(Item, {
      name: "options",
      style: itemStyle,
      validateTrigger: ['onChange', 'onSubmit', 'onBlur', 'onFocus'],
      rules: [{
        required: true,
        validator: this.validateOptions
      }]
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Activity Options:"), /*#__PURE__*/_react.default.createElement(_DynamicOptionItems.default, {
      typeId: typeId,
      disabled: !creative && !editable,
      options: options || [],
      updateOption: this.updateOption,
      addOption: this.addOption,
      removeOption: this.removeOption,
      swapOptionPosition: this.swapOptionPosition
    })), displayQuestions && /*#__PURE__*/_react.default.createElement(Item, {
      name: "questions",
      style: itemStyle,
      validateTrigger: ['onChange', 'onSubmit', 'onBlur', 'onFocus'],
      rules: [{
        required: true,
        validator: this.validateQuestions
      }]
    }, /*#__PURE__*/_react.default.createElement(_DynamicQuestionItems.default, {
      typeId: typeId,
      disabled: !creative && !editable,
      questions: questions || [],
      options: options || [],
      updateQuestion: this.updateQuestion,
      addQuestion: this.addQuestion,
      removeQuestion: this.removeQuestion
    }))), typeId === Type.cyoa && /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "cyoa-form",
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: `tree-${firstId}`,
      name: `tree-${firstId}`,
      validateTrigger: ['onChange', 'onSubmit', 'onBlur', 'onFocus'],
      rules: [{
        required: true,
        validator: this.validateTree
      }]
    }, /*#__PURE__*/_react.default.createElement(_ChooseYourOwnAdventure.default, {
      disabled: !creative && !editable,
      tree: tree,
      firstId: firstId,
      updateTree: this.updateTree
    }))), typeId === Type.screener && /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "screener-form",
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(_ScreenerQuestionForm.default, {
      disabled: !editable && !creative,
      questions: questions,
      options: options,
      updateQuestions: this.updateQuestions,
      updateOptions: this.updateOptions
    })));
  }

}

var _default = ActivityQuestionForm;
exports.default = _default;